import React from 'react'
import style from '../startedsoon/startsoon.module.css'


function Nightingale() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/05b30dd5b1154688b17c563e9366c6b9.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
        <p>HINDI    SCIENCE</p>
        <h4>Nightingale MNS: Crash Course on Biology for MNS 2022 </h4> 
        <p>Lesson 10 • Mar 3, 2022 10:30 AM</p> 
        <p>Shruti Sharma</p>  
        </div>
    </div>        
  )
}
export default Nightingale;